export default __webpack_public_path__ + "static/bruce2-e91609a14137f2ba9042007ce4e1b901.png";